<section>
  <div class="top-bar-container">
    <div class="search-bar-container">
      <app-search-bar
        [placeholder]="'Buscar en vídeos...'"
        [value]="store.searchQuery()"
        (onSearch)="store.updateSearch($event)"
      ></app-search-bar>
    </div>
    <div class="action-buttons-container">
      <app-rfebm-icon-button [iconName]="'video'" (onClick)="onUploadVideo()"
        title="Subir vídeo"></app-rfebm-icon-button>
    </div>
  </div>

  <div class="body-container">
    <div class="title-container">
      <h1>Ánalisis de vídeos</h1>
      <div class="action-buttons-container">
        <app-rfebm-icon-button [iconName]="store.viewMode() === 'list' ? 'grid-view' : 'list-view'"
          (onClick)="store.toggleViewMode()"
          [title]="store.viewMode() === 'list' ? 'Ver en cuadrícula' : 'Ver en lista'"></app-rfebm-icon-button>
        <app-rfebm-icon-button [iconName]="'filter'" (onClick)="setFilterVisible(!showFilter)"></app-rfebm-icon-button>
        <app-rfebm-icon-button [iconName]="'swap'" (onClick)="setSortByVisible(!showSortBy)"></app-rfebm-icon-button>
      </div>
    </div>
    <div class="video-grid-container">
      <div class="window-overlay-container filter-overlay after-hide" [ngClass]="{ hidden: !showFilter }">
        <app-video-filter (onFiltersApplied)="setFilterVisible(false)"></app-video-filter>
      </div>
      <div class="window-overlay-container sortby-overlay after-hide" [ngClass]="{ hidden: !showSortBy }">
        <app-video-sort-by (onSortByApplied)="setSortByVisible(false)"></app-video-sort-by>
      </div>

      <app-video-grid [videoSearchResultListPaginated]="store.videos()" [isInternalUser]="isInternalUser"
        (videoDeleted)="onVideoDeleted()" [pageSize]="store.pageSize()" [viewMode]="store.viewMode()"
        (pageChange)="store.setPage($event)"></app-video-grid>
    </div>
  </div>
</section>
